import React, { useState, useEffect } from "react";
import "./official.scss";
import { Modal } from "antd";
import qinghua from "../../imgs/home/qinghua.png";
import chongqing from "../../imgs/home/chongqing.png";
import tongji from "../../imgs/home/tongji.png";
import jilin from "../../imgs/home/jilin.png";
import florida from "../../imgs/home/florida.png";
import asu from "../../imgs/home/asu.png";
import lab from "../../imgs/home/lab.png";
import zhiling from "../../imgs/home/zhiling.png";
import product from "../../imgs/home/product.png";
import about from "../../imgs/home/about.png";
import caseImg from "../../imgs/home/case.png";
import aboutBackground from "../../imgs/home/background-about.png";
import icon from "../../imgs/home/icon.png";
import wx from "../../imgs/home/wx.png";
import logo from "../../imgs/home/logo.png";
import hongqi from "../../imgs/home/hongqi.png";
import idea from "../../imgs/home/idea.png";
import nameBack from "../../imgs/home/nameBack.png";
import aboutIcon from "../../imgs/home/aboutIcon.png";
import jigou from "../../imgs/home/jigou.png";
import lunwen from "../../imgs/home/lunwen.png";
import technicalTtitle from "../../imgs/home/technicalTtitle.png";
import technical1 from "../../imgs/home/technical1.png";
import technical2 from "../../imgs/home/technical2.png";
import closeDialog from "../../imgs/home/close-dialog.png";
import github from "../../imgs/home/github.png";
import { Button, Carousel } from "antd";
import SignUp from "../../components/sign-up";
import SignIn from "../../components/sign-in";

import useAuthStore from "../../store/auth";
import ResetPassword from "../../components/reset-pwd";

import { useNavigate } from "react-router-dom";

export default function Official() {
  const navigate = useNavigate();
  const path = "https://zl-libra.oss-cn-chengdu.aliyuncs.com/";
  const backgroundVideo = `${path}%E8%83%8C%E6%99%AF%E8%A7%86%E9%A2%91.mp4`; //背景视频
  const ai = `${path}12%E4%B8%AAfeature/AI%E8%87%AA%E5%8A%A8%E6%A3%80%E6%B5%8B.mp4`; //AI自动检测
  const daohang = `${path}12%E4%B8%AAfeature/%E5%AF%BC%E8%88%AA%E8%BE%85%E5%8A%A9%E5%8A%9F%E8%83%BD.mp4`; //导航辅助
  const fangzhen = `${path}12%E4%B8%AAfeature/%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F%E4%BB%BF%E7%9C%9F%E7%8E%AF%E5%A2%83%EF%BC%88%E6%88%90%E9%83%BD%E5%A4%A9%E5%BA%9C%E7%AB%8B%E4%BA%A4%EF%BC%89.mp4`; //数字孪生仿真
  const zengqiang = `${path}12%E4%B8%AAfeature/%E5%A2%9E%E5%BC%BA%E6%98%BE%E7%A4%BA%E5%8A%9F%E8%83%BD.mp4`; //增强显示
  const xingche = `${path}12%E4%B8%AAfeature/%E8%A1%8C%E8%BD%A6%E7%8A%B6%E6%80%81%E5%B1%95%E7%A4%BA.mp4`; //行车状态
  const weather = `${path}12%E4%B8%AAfeature/%E5%A4%A9%E6%B0%94%E5%8F%98%E5%8C%96.mp4`; //天气变化
  const zidong = `${path}12%E4%B8%AAfeature/%E8%87%AA%E5%8A%A8%E9%A9%BE%E9%A9%B6%E6%8E%A7%E8%BD%A6.mp4`; //自动驾驶控车
  const fengxian = `${path}12%E4%B8%AAfeature/%E8%A1%8C%E8%BD%A6%E9%A3%8E%E9%99%A9%E6%8F%90%E7%A4%BA.mp4`; //行车风险提示
  const high = `${path}12%E4%B8%AAfeature/%E9%AB%98%E7%B2%BE%E5%BA%A6%E5%AE%9E%E8%BD%A6%E5%BA%A7%E8%88%B1%EF%BC%88%E5%A4%A7%E4%BC%97%20ID.4%E5%AE%9E%E4%BE%8B%EF%BC%89.mp4`; //高精度
  const game = `${path}12%E4%B8%AAfeature/%E5%BD%B1%E9%9F%B3%E5%A8%B1%E4%B9%90%E5%8A%9F%E8%83%BD.mp4`; //音响娱乐
  const HMI2 = `${path}12%E4%B8%AAfeature/%E6%8E%A5%E7%AE%A1HMI%E6%8F%90%E7%A4%BA.mp4`; //HIM2
  const person = `${path}12%E4%B8%AAfeature/%E4%BA%BA%E5%9B%A0%E6%95%B0%E6%8D%AE%E6%8F%90%E5%8F%96.mp4`; //人因提取
  const caseVideo1 = `${path}%E6%A1%88%E4%BE%8B%E7%A4%BA%E6%84%8F/%E4%B8%BB%E6%B5%81%E6%A0%87%E6%9D%86.mp4`; //主流标杆
  const caseVideo2 = `${path}%E6%A1%88%E4%BE%8B%E7%A4%BA%E6%84%8F/%E5%88%9B%E6%83%B3%E6%97%A0%E9%99%90.mp4`; //创想无限
  const currentImage = `${path}%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg`; //微信二维码
  const [activeTab, setActiveTab] = useState("");
  const [videoSrc, setVideoSrc] = useState(caseVideo1); // 初始视频源为视频1
  const [selectedButton, setSelectedButton] = useState("mainstream"); // 记录当前选中的按钮
  // const [email, setEmail] = useState(""); // 存储输入框的邮箱值
  const [isSticky, setIsSticky] = useState(false); // 控制标题
  // 状态来控制图片弹窗的显示
  const [showImage, setShowImage] = useState(false);
  // 注册
  const [signUpVisible, setSignUpVisible] = useState(false);
  // 登录
  const [signInVisible, setSignInVisible] = useState(false);

  // 重置密码
  const [resetVisible, setResetVisible] = useState(false);

  const { userInfo } = useAuthStore();

  // 点击按钮时显示图片
  const handleImageClick = () => {
    setShowImage(true); // 打开弹窗
  };

  // 关闭图片弹窗
  const closeImagePopup = () => {
    setShowImage(false); // 关闭弹窗
  };
  // 监听滚动事件，控制标题的样式和高亮
  useEffect(() => {
    const homeBox = document.querySelector(".home-box");
    const sections = document.querySelectorAll(".white-box");

    const handleScroll = () => {
      // 判断标题是否固定
      if (homeBox.scrollTop > 75) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      const scrollPosition = homeBox.scrollTop;

      if (scrollPosition === 0) {
        setActiveTab(null);
        return;
      }

      let maxVisibility = 0;
      let activeSection = null;

      // 遍历所有部分，计算每个部分的可见区域占比
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionHeight = rect.bottom - rect.top; // 计算该部分的高度
        const visibleTop = Math.max(0, -rect.top); // 可见区域的上端
        const visibleBottom = Math.max(0, rect.bottom - window.innerHeight); // 可见区域的下端
        const visibleArea = sectionHeight - visibleTop - visibleBottom; // 可见区域的面积

        const visibilityRatio = visibleArea / sectionHeight; // 计算可见区域占比

        // 如果该部分的可见区域占比更大，更新高亮部分
        if (visibilityRatio > maxVisibility) {
          maxVisibility = visibilityRatio;
          activeSection = section.id;
        }
      });

      // 设置高亮
      if (activeSection) {
        setActiveTab(activeSection);
      }
    };

    homeBox.addEventListener("scroll", handleScroll);
    return () => {
      homeBox.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMainstreamClick = () => {
    setVideoSrc(caseVideo1);
    setSelectedButton("mainstream");
  };

  const handleCreativeClick = () => {
    setVideoSrc(caseVideo2);
    setSelectedButton("creative");
  };
  // 邮箱跳转
  // const goHome = () => {
  //   if (!email) {
  //     // message.error("请输入邮箱地址");
  //     return;
  //   }
  //   // http://localhost:5001/add-email
  //   // https://hud-ui-api.dinglantech.com/add-email
  //   fetch("http://localhost:5001/add-email", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ email: email }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log(data);
  //       if (data.status === 'success') {
  //         message[data.status](data.message);
  //         // message.success(data.message);
  //         navigate('/home');
  //       }
  //       else if (data.status === 'error' && data.message === '您已申请') {
  //         navigate('/home');
  //       }
  //       else {
  //         message.error(data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // };

  //跳转到github
  const goGitHub = () => {
    window.location.href = "https://github.com/ZhilingResearch/Libra";
  };
  // 点击链接时,更新 activeTab
  // const handleClick = (tabName, e) => {
  //   e.preventDefault();
  //   setActiveTab(tabName);
  //   const targetElement = document.getElementById(tabName);
  //   if (targetElement) {
  //     targetElement.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleClick = (tabName, e) => {
    e.preventDefault();
    setActiveTab(tabName);
    const targetElement = document.getElementById(tabName);
    if (targetElement) {
      const headerHeight = document.querySelector(".home-title").offsetHeight;
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      window.scrollBy(0, -headerHeight);
    }
  };

  // 图片路径数组
  const images = [tongji, qinghua, chongqing, jilin, florida, asu];
  // 产品功能视频数据
  const videoData = [
    [
      { src: ai, text: "AI自动检测" },
      { src: daohang, text: "导航辅助功能" },
      { src: fangzhen, text: "数字孪生仿真环境（成都天府立交）" },
    ],
    [
      { src: zengqiang, text: "增强显示功能" },
      { src: xingche, text: "行车状态展示" },
      { src: weather, text: "天气变化" },
    ],
    [
      { src: zidong, text: "自动驾驶控车" },
      { src: fengxian, text: "行车风险提示" },
      { src: high, text: "高精度实车座舱（大众 ID.4实例）" },
    ],
    [
      { src: game, text: "影音娱乐功能" },
      { src: HMI2, text: "接管HMI提示" },
      { src: person, text: "人因数据提取" },
    ],
  ];

  return (
    <div className="home-box">
      <div className="box">
        {/* 右侧图标 */}
        <div className="icon">
          <div className="icon-item">
            <img src={icon} alt="" onClick={() => handleImageClick(icon)} />
            <img src={wx} alt="" onClick={() => handleImageClick(wx)} />
          </div>
        </div>
        {/* 弹窗显示当前图片 */}
        {showImage && (
          <div className="image-popup">
            <div
              className="image-popup-overlay"
              onClick={closeImagePopup}
            ></div>
            <div className="image-popup-content">
              <img
                src={currentImage}
                alt="Popup"
                style={{ width: "100%", height: "100%" }}
              />
              <img
                src={closeDialog}
                onClick={closeImagePopup}
                className="closeDialog"
                alt=""
              />
              <div className="phone">扫码添加企微</div>
              <div className="phone1">获取详细信息</div>
            </div>
          </div>
        )}
        <header className={`header-box ${isSticky ? "sticky" : ""}`}>
          <div className="home-title">
            <div className="logo">
              <div className="logo-item">
                <img src={logo} alt="" />
              </div>
              <div className="title-text">
                <a
                  className={`tab-item ${
                    activeTab === "product" ? "active" : ""
                  }`}
                  href="#product"
                  onClick={(e) => handleClick("product", e)}
                >
                  产品功能
                </a>
                <a
                  className={`tab-item ${activeTab === "case" ? "active" : ""}`}
                  href="#case"
                  onClick={(e) => handleClick("case", e)}
                >
                  案例示意
                </a>
                <a
                  className={`tab-item ${activeTab === "tech" ? "active" : ""}`}
                  href="#tech"
                  onClick={(e) => handleClick("tech", e)}
                >
                  技术实现
                </a>
                <a
                  className={`tab-item ${
                    activeTab === "about" ? "active" : ""
                  }`}
                  href="#about"
                  onClick={(e) => handleClick("about", e)}
                >
                  关于我们
                </a>
              </div>
            </div>
            <div className="button">
              {/* <Button
                type="primary"
                className="gradient-button"
                onClick={() => handleImageClick()}
              >
                免费使用
              </Button> */}
              {/* <div
                className="login"
                style={{ cursor: "pointer" }}
                onClick={() => handleImageClick()}
              >
                登录
              </div> */}

              {!!userInfo?.user?.nickname ? (
                <span className="nav-btn" onClick={() => navigate("/home")}>
                  进入LIBRA
                </span>
              ) : (
                <>
                  <span
                    className="nav-btn"
                    onClick={() => setSignUpVisible(true)}
                  >
                    注册使用
                  </span>
                  <span
                    className="nav-btn"
                    onClick={() => setSignInVisible(true)}
                  >
                    登录账号
                  </span>
                </>
              )}
              <a
                href="https://cloudcity.zhilingtech.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="智翎云境"
                style={{ color: "white", textDecoration: "none" }}
              >
                智翎云境
              </a>
            </div>
          </div>
        </header>
        {/* 第一部分 */}
        <div className="content">
          <video className="background-video" autoPlay loop muted playsInline>
            <source src={backgroundVideo} type="video/mp4" />
          </video>
          <div className="content-title">
            <div className="car">
              <div>车载HUD智能设计与验证</div>
              <div>一站式平台</div>
            </div>
            <div className="car-text">
              <div className="car-text-item">基于顶尖高校最新成果孵化</div>
              <div className="car-text-item">
                包含AI检测,虚拟仿真与真人在环实验等多种技术方案
              </div>
              <div className="car-text-item">
                与全球科研机构和工业界广泛开展合作
              </div>
            </div>
            {/* <div className="content-input">
              <div className="input-container">
                <Input
                  size="large"
                  placeholder="请输入邮箱"
                  className="email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  type="primary"
                  size="large"
                  className="submit-button"
                  onClick={goHome}
                >
                  开始使用
                </Button>
              </div>
            </div> */}
          </div>
          {/* 高校图标 */}

          <div className="school-icon">
            {images.map((image, index) => (
              <img key={index} src={image} alt={`school-icon-${index}`} />
            ))}
          </div>
        </div>

        {/* 产品功能*/}
        <div className="white-box" id="product">
          <div className="product-title">
            <img src={product} alt="" />
          </div>
          <div className="product-content">
            <Carousel autoplay className="custom-carousel">
              <div className="carousel">
                <div className="product-item">
                  {/* 第一组数据 */}
                  {videoData[0].map((video, index) => (
                    <div key={index} className="dazhong">
                      <div className="dazhong-video">
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="video-cls"
                        >
                          <source src={video.src} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dazhong-text">{video.text}</div>
                    </div>
                  ))}
                </div>

                <div className="product-item" style={{ marginTop: "10px" }}>
                  {/* 第二组数据 */}
                  {videoData[1].map((video, index) => (
                    <div key={index} className="dazhong">
                      <div className="dazhong-video">
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="video-cls"
                        >
                          <source src={video.src} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dazhong-text">{video.text}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="carousel">
                <div className="product-item">
                  {/* 第三组数据 */}
                  {videoData[2].map((video, index) => (
                    <div key={index} className="dazhong">
                      <div className="dazhong-video">
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="video-cls"
                        >
                          <source src={video.src} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dazhong-text">{video.text}</div>
                    </div>
                  ))}
                </div>
                <div className="product-item" style={{ marginTop: "10px" }}>
                  {/* 第四组数据 */}
                  {videoData[3].map((video, index) => (
                    <div key={index} className="dazhong">
                      <div className="dazhong-video">
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="video-cls"
                        >
                          <source src={video.src} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dazhong-text">{video.text}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Carousel>
          </div>
        </div>
        {/* 案例示意 */}
        {/* <div className="white-box" id="case" style={{ height: "900px" }}> */}
        <div className="white-box" id="case">
          <div className="product-title">
            <img src={caseImg} alt="Case" />
          </div>
          <div className="case-content">
            <video
              key={videoSrc}
              className="case-video"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={videoSrc} type="video/mp4" />
            </video>

            {/* 按钮 */}
            <div className="case-btn">
              <div
                className="btn-item"
                style={{ background: "rgba(226, 246, 255, 0.4)" }}
              >
                <div className="change">
                  <img src={hongqi} alt="" />
                </div>
                <div className="change">
                  <Button
                    type="primary"
                    style={{
                      background:
                        selectedButton === "mainstream"
                          ? "#33C9DD"
                          : "transparent",
                      color: "white",
                      border:
                        selectedButton === "mainstream"
                          ? "none"
                          : "1px dashed white",
                    }}
                    onClick={handleMainstreamClick}
                  >
                    主流标杆
                  </Button>
                </div>
                <div className="change">
                  轻松复现主流车企HUD设计方案,深度解析行业标准与技术细节
                </div>
              </div>
              <div className="btn-item">
                <div className="change">
                  <img src={idea} alt="" />
                </div>
                <div className="change">
                  <Button
                    style={{
                      background:
                        selectedButton === "creative"
                          ? "#33C9DD"
                          : "transparent",
                      color: "white",
                      border:
                        selectedButton === "creative"
                          ? "none"
                          : "1px dashed white",
                    }}
                    onClick={handleCreativeClick}
                  >
                    创想无限
                  </Button>
                </div>
                <div className="change">
                  自主创新设计,自由组合,探索HUD新可能
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 技术实现 */}
        <div className="white-box" id="tech">
          <div className="product-title">
            <img src={technicalTtitle} alt="Case" />
          </div>

          {/* <div
            className="product-content"
            style={{ width: "1100px", height: "78%" }}
          > */}
          <div className="product-content" style={{ width: "1100px" }}>
            <Carousel autoplay className="custom-carousel">
              <div className="carousel">
                <img src={technical1} alt="" className="technical" />
              </div>

              <div className="carousel">
                <img src={technical2} alt="" className="technical" />
              </div>
            </Carousel>
          </div>
        </div>
        {/* 关于我们 */}
        <div
          className="white-box"
          id="about"
          style={{
            background: `url(${aboutBackground}) no-repeat center center`,
            backgroundSize: "cover",
          }}
        >
          <div className="product-title">
            <img src={about} alt="About" />
          </div>
          <div
            className="product-content"
            style={{
              width: "1100px",
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              className="about-item"
              style={{
                background: `url(${nameBack}) no-repeat center center`,
                width: "400px",
                backgroundSize: "cover",
              }}
            >
              <div className="jigou">
                <img src={jigou} alt="" />
                <div className="jigou-icon">
                  <span className="num">4</span>
                  <span className="num1">+</span>
                </div>
                <img src={aboutIcon} alt="" />
              </div>

              <div className="jigou">
                <img src={lunwen} alt="" />
                <div className="jigou-icon">
                  <span className="num">6</span>
                  <span className="num1">+</span>
                </div>
                <img src={aboutIcon} alt="" />
              </div>
            </div>
            <div className="about-item lunwen">
              <div style={{ paddingLeft: "30px" }}>
                {" "}
                LIBRA拥有一支由高校、车企和行业协会成员组成的多元化团队，致力于构
              </div>
              <div>
                建面向全球的智能汽车人机交互新生态。LIBRA以用户需求为导向，专注于提升
              </div>
              <div>
                人机交互技术品质；通过打造可信、可靠的开源研发与测试平台，建立标准化的
              </div>
              <div>
                数据共享与协作机制，LIBRA为开发者、研究人员和产业实践者提供灵活易用的
              </div>
              <div>
                标准化研发工具和测试环境，降低技术研发门槛，打破汽车、交通、机械、工业
              </div>
              <div>
                工程等不同行业的信息壁垒，促进跨行业协同。通过打造一个包容性强的开放社
              </div>
              <div>
                区，LIBRA吸引全球从业者共同推动智能、安全、友好的智能汽车人机交互的突
              </div>
              <div>破性创新和落地应用。</div>
              {/* <div style={{ fontWeight: "bold" }}>合作联系与软件使用：libra@zhilingresearch.com</div> */}
            </div>
          </div>
        </div>

        {/* 底部 */}
        <div className="end-content">
          <div
            style={{
              width: "1100px",
              height: "75%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="end-logo">
              <img src={zhiling} alt="" />
              <img src={lab} alt="" />
            </div>

            <div className="end-email">
              <div className="github" onClick={goGitHub}>
                <img src={github} alt="" className="github-name" />
                <span>Github</span>
              </div>
              <div>合作联系与软件使用：libra@zhilingresearch.com</div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={signUpVisible}
        footer={null}
        className="login-modal"
        style={{ background: "#DAE0FFE5" }}
        maskClosable={true}
        closeIcon={null}
        onCancel={() => setSignUpVisible(false)}
        destroyOnHidden
      >
        <SignUp
          onSignIn={() => {
            setSignUpVisible(false);
            setSignInVisible(true);
          }}
        />
      </Modal>

      <Modal
        open={signInVisible}
        footer={null}
        className="login-modal"
        style={{ background: "#DAE0FFE5" }}
        maskClosable={true}
        closeIcon={null}
        onCancel={() => setSignInVisible(false)}
        destroyOnClose
      >
        <SignIn
          onSignUp={() => {
            setSignInVisible(false);
            setSignUpVisible(true);
          }}
          onReset={() => {
            setSignInVisible(false);
            setResetVisible(true);
          }}
        />
      </Modal>

      <Modal
        open={resetVisible}
        footer={null}
        className="login-modal"
        style={{ background: "#DAE0FFE5" }}
        maskClosable={true}
        closeIcon={null}
        onCancel={() => setResetVisible(false)}
        destroyOnClose
      >
        <ResetPassword
          onSignIn={() => {
            setResetVisible(false);
            setSignInVisible(true);
          }}
        />
      </Modal>
    </div>
  );
}
